import palette from '../../palette';

export default {
  root: {
    ['@media (max-width: 768px)']: {
      left: "24px",
      right: "24px"
    },
  },
};